
const useGradeOfAllocationCell = () => {
    const gradeOfAllocation = {
        accessorKey: 'reading_assessment_grade_of_execution_name',
        header: "שכבת ביצוע",
        feature: "grade-of-allocation",
        role: "read"
    }

    return gradeOfAllocation
}

export default useGradeOfAllocationCell